<template>
  <div>
    <div class="weui-mask" @click="close"
         :class="[isShow ? 'mask-show' : 'mask-hide',maskRealHide ? 'mask-real-hide':'']"></div>
    <div class="weui-actionsheet" :class="[isShow ? 'weui-actionsheet_toggle':'']">
      <div class="c-actionsheet__header" v-if="slotShow.head">
        <div class="head_cancel__btn" @click="sendEvent('cancel')">取消</div>
        <div class="head_title">
          <slot name="head"></slot>
        </div>
        <div class="head_sure__btn" @click="sendEvent('ensure')">确定</div>
      </div>
      <div class="weui-actionsheet__title" v-if="slotShow.title">
        <p class="weui-actionsheet__title-text">
          <slot name="title"></slot>
        </p>
      </div>
      <div class="weui-actionsheet__menu">
        <slot name="menu"></slot>
      </div>
      <div class="weui-actionsheet__action" v-if="slotShow.action">
        <slot name="action"></slot>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import './index.scss';
</style>
<script>
  export default {
    name: 'c-action-sheet',
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isShow: false,
        maskRealHide: true,
        slotShow: {}
      }
    },
    components: {},
    created () {
      this.slotShow = {
        title: 'title' in this.$slots, // 控制div区域是否渲染
        action: 'action' in this.$slots,
        head: 'head' in this.$slots
      }
      if (this.visible) this.open()
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      open () {
        this.isShow = true
        this.maskRealHide = false
        this.syncVisible(this.isShow)
      },
      close () {
        this.isShow = false
        this.syncVisible(this.isShow)
        setTimeout(() => {
          this.maskRealHide = true
        }, 220)
      },
      syncVisible (value) {
        this.$emit('update:visible', value)
      },
      sendEvent (eventName) {
        this.$emit(eventName)
      }
    },
    computed: {},
    watch: {
      visible (val) {
        val ? this.open() : this.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?73533b44